<template>
  <div class="wrap">
  	<!-- <div class="download-title" v-if="isPwd=='true'">
      <div class="title-text">亲爱的用户{{phone_number}}，恭喜您的款项已审批，请设置密码后立即领取</div>
      <input type="password" placeholder="请输入任意字符，长度为6-20位的密码" v-model="pwd" maxlength="20">
    </div> -->
    <div class="phone-fix">
      {{phone_number}}
    </div>
    
  	<div class="down" @click="download">
  		<!-- 立即拿钱 -->
  	</div>
    <div class="errorPrompt">
      {{prompt}}
    </div>
  </div>
</template>


<script>
export default {
  name: "Register",
  data() {
    return {
      canClick: true,
      url: "",
      download_if: false,
      phone_number: "",
      number: "",
      pwd: "",
      model_show: false,
      prompt: "",
      code: "",
      isPwd: "true"
    };
  },
  watch: {
    pwd() {
      // console.log(this.pwd.length)
      if (this.pwd.length == 0 || this.pwd.length > 5) {
        this.prompt = "";
      }
    }
  },

  created() {
    let m = location.search.match(/td_channelid=(\w+)/);
    this.cid = (m && m[1]) || "test";

    let reg = new RegExp("(^|&)n=([^&]*)(&|$)");
    let reg2 = new RegExp("(^|&)ispwd=([^&]*)(&|$)");

    this.number = window.location.search.substr(1).match(reg);
    this.number = unescape(this.number[2]);

    let isPwd = window.location.search.substr(1).match(reg2);
    if (isPwd != null) {
      this.isPwd = unescape(isPwd[2]);
    }

    // console.log(this.isPwd == "true");

    this.phone_number =
      this.number.substr(0, 3) + "****" + this.number.substr(7);

    this.code = this.getCookie("code");
  },

  methods: {
    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    download() {
      // 下载处理
      let m = location.search.match(/td_channelid=(\w+)/);
      let agent = window.navigator.userAgent;
      let isWechat = /MicroMessenger/.test(agent);
      let isIOS = /iPad|iPhone|iPod/.test(agent) && !window.MSStream;
      let isAndroid = /Android/i.test(agent) && !window.MSStream;
      let sys = isIOS ? "ios" : isWechat ? "wechat" : "android";

      let this_params = { number: this.number, code: this.code };
      // if (this.isPwd == "true") {
      //   this_params.pwd = this.pwd;
      // }

      // if (
      //   (this.pwd.length < 6 || this.pwd.length > 20) &&
      //   this.isPwd == "true"
      // ) {
      //   this.prompt = "请输入任意字符，长度为6-20位的密码!";
      //   this.model_show = true;
      //   clearTimeout(setTO);
      //   let setTO = setTimeout(() => {
      //     this.model_show = false;
      //   }, 1000);
      // } else {
      if(sessionStorage[this.number]){
        this.app_download(sessionStorage[this.number])
        return
      }

      this.$http.post(process.env.API_ROOT + "/land/apply", this_params).then(
        data => {
          sessionStorage[this.number] = data.data
          this.app_download(data.data)
        },
        response => {
          this.prompt = "请刷新重试!";
          this.model_show = true;
          clearTimeout(setTO);
          let setTO = setTimeout(() => {
            this.model_show = false;
          }, 1000);
        }
      );
      // }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input {
  box-sizing: border-box;
  outline: none;
  margin: 0 auto;
  height: 44px;
  /* width: 16rem; */
  /* padding: 0 2rem; */
  border-radius: 12px;
  width: 100%;
  border: 1px solid #dedede;
  padding: 0 0.5rem;
  font-size: .48rem;
  text-indent: 10px;
  margin: 10px 0;
  margin-bottom: 0;
}
.down {
  box-sizing: border-box;
  height: 1.3rem;
  width: 100%;
  line-height: 1.3rem;
  border-radius: .7rem;
  margin: 0 auto;
  /* background: red; */
  position: relative;
  font-size: .48rem;
  font-weight: bold;
  margin-top: 4.5rem;
  /* background: red; */

}
.download-title {
  position: relative;
  text-align: center;
  /*line-height: 4rem;*/
  /*font-size: 1rem;*/
  color: #7849ff;
}
.title-text {
  margin: 0 auto;
  width: 18rem;
  text-align: left;
  /* color: #ff6000; */
  color: #fff;
}
.wrap {
  /* height: 5rem; */
  transition-duration: 1s;
}
.model {
  /* position: fixed;
  left: 50%;
  top: 50%;
  width: 15rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  margin-left: -7.5rem;
  margin-top: -1rem;
  font-size: 0.6rem;
  background: #000;
  opacity: 0.4;
  color: #fff; */
}
.bottom-img {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0;
  margin-bottom: 30px;
  margin-top: 10px;
}
.errorPrompt {
  text-align: center;
  /* padding-left: 16px; */
  color: #fff;
  font-size: .48rem;
  height: 24px;
}
.phone-fix {
  position: absolute;
  left: 0;
  top: 10.4rem;
  width: 100%;
  font-size: 0.6rem;
  text-align: center;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Download2.vue